import { LOCATION_PLACE_TYPE } from '../../../types/services';
import { IShipmentData } from '../../../types/orders';
import { NudosGenericModal, NudosModalContent } from '../../NudosComponents';
import NudosEditOfficeAddressModal from './NudosEditOfficeAddressModal/NudosEditOfficeAddressModal';
import NudosEditUserAddressModal from './NudosEditUserAddressModal/NudosEditUserAddressModal';

const NudosEditAddressModal = ({
  closeModalCallback,
  shipInfo,
  organizationId,
  updateWithoutLoaders
}: {
  closeModalCallback: () => void;
  shipInfo: IShipmentData;
  organizationId: number;
  updateWithoutLoaders: () => void;
}) => {
  const placeIsUser = shipInfo?.place === LOCATION_PLACE_TYPE.USER;
  const placeIsOffice = shipInfo?.place === LOCATION_PLACE_TYPE.OFFICE;
  const modalHeight = placeIsUser ? '520px' : '567px';

  const getModalTitle = () => {
    if (placeIsUser) return 'Editar Información del empleado';
    if (placeIsOffice) return 'Editar información del destino';
    return 'Otra dirección';
  };

  const nudosEditDirectionModalContent = placeIsUser ? (
    <NudosEditUserAddressModal
      closeModalCallback={closeModalCallback}
      shipInfo={shipInfo}
      updateWithoutLoaders={updateWithoutLoaders}
    />
  ) : (
    <NudosEditOfficeAddressModal
      closeModalCallback={closeModalCallback}
      shipInfo={shipInfo}
      organizationId={organizationId}
      updateWithoutLoaders={updateWithoutLoaders}
    />
  );

  return (
    <div className="nudosEditAddressModal">
      <NudosGenericModal
        closeModalCallback={() => closeModalCallback()}
        clickOutsideCallback={() => closeModalCallback()}
        modalContent={
          <NudosModalContent
            customWidth="636px"
            customHeight={modalHeight}
            toCloseModal={closeModalCallback}
            modalContentTitle={getModalTitle()}
            CustomModalComponent={nudosEditDirectionModalContent}
          />
        }
      />
    </div>
  );
};

export default NudosEditAddressModal;
